import { createContext } from "react";
import { AthleteActions } from "../AthletesProvider.types";

const AthleteActionsContext = createContext<AthleteActions | undefined>(undefined);
AthleteActionsContext.displayName = "AthleteActionsContext";

export default AthleteActionsContext;
